module.exports = __webpack_public_path__ + "static/media/2.eb256214.svg";